"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Network_1 = __importDefault(require("../../interface/Network"));
const Token_1 = __importDefault(require("../../interface/Token"));
const Handler_1 = __importDefault(require("../../interface/Handler"));
const Method_1 = __importDefault(require("../../interface/Method"));
const EntryPoint_1 = __importDefault(require("../../interface/EntryPoint"));
exports.default = new Network_1.default('kovan', [
    new Token_1.default('ether', 'ETH', 'bifi', 0, '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE', '', false, false, false, [], '{} ETH', 'icon/eth.svg'),
    new Token_1.default('usdt', 'USDT', 'bifi', 1, '0x38DaFB6F33aFa2276b3B5636d76769e849d99335', '', false, true, false, [], '{} USDT', 'icon/usdt.svg'),
    new Token_1.default('dai', 'DAI', 'bifi', 2, '0x3Acb14b76496824513FaE001632071bffCBDb5Ce', '', false, true, false, [], '{} DAI', 'icon/dai.svg'),
    new Token_1.default('link', 'LINK', 'bifi', 3, '0x0a3061773FB691A6a0E988f77227a2F60A4BA68F', '', false, true, false, [], '{} LINK', 'icon/link.svg'),
    new Token_1.default('usdc', 'USDC', 'bifi', 4, '0x6329AA0D5EFd943cBdC8e31934361E5B8899D438', '', false, true, false, [], '{} USDC', 'icon/usdc.svg'),
    new Token_1.default('btc', 'BTC', 'bifi', 5, '0x9bc3775A20cA8a0CeB609525484678E44E3a4b9D', '', false, true, false, [], '{} BTC', 'icon/btc.svg'),
    new Token_1.default('dot', 'DOT', 'bifi', -1, '', '', true, true, true, [], '{} DOT', 'icon/dot.svg'),
    new Token_1.default('kaia', 'KAIA', 'bifi', -1, '', '', true, true, true, [], '{} KAIA', 'icon/kaia.svg'),
    new Token_1.default('bfceth', 'UNI-V2', 'pool.bfceth', -1, '0xe7f4C32a3ac5A2366643eeeBcF83D3eA4c0CB2dD', '', false, true, false, [
        'bfc',
        'ether'
    ], '{} UNI-V2', 'icon/bfceth.svg'),
    new Token_1.default('bifieth', 'UNI-V2', 'pool.bifieth', -1, '0x6f99f4605f5d67171E8f079D7a2d5f853BB5040c', '', false, true, false, [
        'bifi',
        'ether'
    ], '{} UNI-V2', 'icon/bifieth.svg'),
    new Token_1.default('bfc', 'BFC', 'stake.bfc', -1, '0x20353D5349871843d3845cD82e13d944a19332C9', '', false, true, false, [], '{} BFC', 'icon/bfc.svg'),
    new Token_1.default('bifi', 'BiFi', '', -1, '0xd28b8234927F41c2E77d8E41FE656443763983CC', '', false, true, false, [], '{} BiFi', 'icon/bifi.svg')
], [
    new Handler_1.default(0, 'ether'),
    new Handler_1.default(1, 'usdt'),
    new Handler_1.default(2, 'dai'),
    new Handler_1.default(3, 'link'),
    new Handler_1.default(4, 'usdc'),
    new Handler_1.default(5, 'btc')
], [
    new Method_1.default('bifi.market', 'callProxyMarket_getMarket()', [], [
        '(uint256,address,uint256,uint256,uint256,uint256,uint256)[]',
        'bool'
    ]),
    new Method_1.default('bifi.user', 'callProxyUser_getUser(address)', ['user.address'], [
        '(uint256,address,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256,uint256)[]',
        '(uint256,uint256,uint256,uint256)'
    ]),
    new Method_1.default('bifi.si', 'callProxySI_getSI(address)', ['user.address'], [
        'address',
        '(uint256,uint256,uint256,uint256,uint256,uint256)[]',
        '(uint256,uint256,uint256,uint256)',
        'uint256'
    ]),
    new Method_1.default('bifi.circuitBreak', 'callProxyManager_getCircuitBreaker()', [], ['bool']),
    new Method_1.default('bifi.btcUserInfo', 'getETHUserInfo(address)', ['user.address'], ['address[]']),
    new Method_1.default('bifi.refundAddr', 'getRefundAddr(address)', ['user.address'], ['address']),
    new Method_1.default('srd.market', 'marketInformation(uint256,uint256)', [
        'blockNumber.from',
        'blockNumber.to'
    ], ['(uint256,uint256,uint256,uint256)']),
    new Method_1.default('srd.user', 'userInformation(address,uint256,uint256)', [
        'user.address',
        'blockNumber.from',
        'blockNumber.to'
    ], ['(uint256,uint256,uint256,uint256,uint256)'])
], [
    new EntryPoint_1.default('bifi', '0x0B5759BC865fd7c3F579217526131083C5a9595E'),
    new EntryPoint_1.default('bifi.resolver', '0xDE72917d9D3e4BaD1b540E207c118000c3B30e50'),
    new EntryPoint_1.default('pool.bfceth', '0x230AdF3c7E6F2c9A4630C0A409cFD17fD1036Fe0'),
    new EntryPoint_1.default('pool.bifieth', '0x4A3259495cECA5174b0618C449A676Ee68763271'),
    new EntryPoint_1.default('stake.bfc', '0x83a8570B2B28e747b25Acc7759D183ccB7dD4F66')
], 13000);
//# sourceMappingURL=kovan.js.map